import { getRouteApi } from '@tanstack/react-router';

export const overrideManagementRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/override-management/',
);
